module.exports = __webpack_public_path__ + "static/media/priceNew.6ab8ce6c.svg";